import { EuiSpacer } from '@elastic/eui';
import FTPTable from 'components/Web_User_Interface/720p_Series/Alarm/FTP/ftpTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  FTPTable,
  BreadCrumbs,
  SEOHelmet,
  React
};